import { DEPOSIT_EVENTS } from "@/events";
import { useEventListener, useDialogPortal } from "@/hooks";
import { useTokenForm } from "@/hooks";
import { TOKEN_IDS } from "@/types";

export function useDepositForm() {
    const {
        form,
        amount: depositAmount,
        amountError: depositAmountError,
        selectedTokenId,
        selectTokenId,
        setMaxAmount,
        resetAmount,
        isMaxDisabled,
        isAmountOverBalance,
    } = useTokenForm({
        defaultTokenId: TOKEN_IDS.USDC,
    });

    const { openDepositTransactionDialog } = useDialogPortal();

    useEventListener(DEPOSIT_EVENTS.SUCCESS, resetAmount);

    const submitDeposit = form.handleSubmit(() => {
        const payload = {
            depositAmount: Number(depositAmount.value),
            depositTokenId: selectedTokenId,
        };
        openDepositTransactionDialog(payload);
    });

    return {
        depositAmount,
        depositAmountError,
        selectedTokenId,
        submitDeposit,
        selectTokenId,
        setMaxAmount,
        isMaxDisabled,
        isAmountOverBalance,
    };
}
